export interface IBrowserObject {
    name: string;
    version: number;
}

export enum BrowserVersions {
    Chrome = 38,
    Firefox = 46,
    Edge = 12,
    Opera = 28
}

type mobileOS = 'Android' | 'BlackBerry' | 'iOS' | 'Opera' | 'Windows' | 'any';

export class BrowserIdentifier {

    public static isIE() {
        const browser = this.nameAndVersion;
        return browser.name === 'MSIE';
    }

    public static isFirefox() {
        const browser = this.nameAndVersion;
        return browser.name === 'Firefox';
    }

    public static isEdge() {
        const browser = this.nameAndVersion;
        return browser.name === 'Edge';
    }

    public static isChrome() {
        const browser = this.nameAndVersion;
        return browser.name === 'Chrome';
    }

    public static isMobile(name?: mobileOS) {
        const userAgent = window.navigator.userAgent;
        const checkMobile = {
            Android: () => userAgent.match(/Android/i),
            BlackBerry: () => userAgent.match(/BlackBerry/i),
            iOS: () => userAgent.match(/iPhone|iPad|iPod/i),
            Opera: () => userAgent.match(/Opera Mini/i),
            Windows: () => userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i),
            any: () => (
                checkMobile.Android() ||
                checkMobile.BlackBerry() ||
                checkMobile.iOS() ||
                checkMobile.Opera() ||
                checkMobile.Windows()
            ),
        };
        return !!(checkMobile[name || 'any'])();
    }

    private static internalNameAndVersion: IBrowserObject;
    private static get nameAndVersion(): IBrowserObject {
        if (this.internalNameAndVersion) {
            return this.internalNameAndVersion;
        } else {
            this.internalNameAndVersion = this.getBrowserNameAndVersion();
            return this.internalNameAndVersion;
        }
    }

    public static detectBrowser(): string {
        const ua = navigator.userAgent;
        let tem;
        let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'MSIE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return M.join(' ');
    }

    public static getBrowserNameAndVersion(): IBrowserObject {
        const browser = BrowserIdentifier.detectBrowser();
        const spaceIndex = browser.indexOf(' ');
        const browserName = browser.substring(0, spaceIndex);
        const browserVersion = browser.substring(spaceIndex + 1, browser.length);
        return { name: browserName, version: parseFloat(browserVersion) };
    }
}
